export default {"src":"/_next/static/media/new_password.111c947e.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};